import { useEffect } from 'react'
import { ensurePushSubscription } from '@/shared/lib/pushNotifications'

/**
 * Self-heals a dropped push subscription, once per authenticated launch.
 * Mounted inside AppLayout (behind the auth boundary), so it never runs on
 * public/unauthenticated routes.
 *
 * iOS can silently drop a PWA's push subscription (OS updates, storage
 * eviction) with the notification permission still 'granted'. Nothing
 * re-creates it otherwise — the launch path is read-only — so a user can
 * silently stop receiving assignment/mention pushes. This re-subscribes
 * invisibly when (and only when) the browser sub has actually gone missing.
 *
 * Frictionless by construction: ensurePushSubscription never prompts and does
 * zero work unless permission is already granted AND the sub is gone. The
 * explicit opt-in/out paths (PersonalPushToggle / PWAOnboardingBanner) are
 * untouched — this only heals, it never changes the user's opt-in choice.
 */
export function usePushSubscriptionSync() {
  useEffect(() => {
    void ensurePushSubscription()
  }, [])
}
